<template>
    <div class="is_group">
        <p class="title">{{productData.groupName}}</p>
        <img class="status_icon" src="https://appd.knowbox.cn/ss/activity/group-buy/buy-success.png" alt="" srcset="">
        <groupPerson :headList="productData.groupInfo.headList"></groupPerson>
        <div v-if='productData.groupInfo.courseTime' class="time">
            <span>上课时间：</span>
            <span>{{productData.groupInfo.courseTime}}</span>
        </div>
        <div class="groupDesc">
            <img v-for="(item, index) in productData.groupDescImgList" :key="index" :src="item" alt="">       
        </div>
        <button @click=" isRunInWeChat ? toWxDetail() :  toDetail()">查看课程</button>
    </div>
</template>

<script>
import groupPerson from "./group_person.vue";
import { MOBILE_API } from "@/constants/api";
import { isRunInWeChat } from "../../../utils/env";

export default {
  name: "is_group",
  props: {
    productData: Object,
    department: String
  },
  components: {
    groupPerson
  },
  data() {
    return {
      isRunInWeChat: isRunInWeChat()
    };
  },
  created: function() {},
  methods: {
    toDetail() {
      switch (this.department) {
        case "1":
          //小象编程前端域名
          const eleDomain = {
            dev: "https://qacode3.knowbox.cn/",
            test: "https://qacode3.knowbox.cn/",
            preview: "https://code.knowbox.cn/",
            production: "https://code.knowbox.cn/"
          };
          window.location.href =
            eleDomain[process.env.VUE_APP_INTER] +
            "activity/activitypage/appnewsuccess.html?appxhktToken=" +
            encodeURIComponent(localStorage.getItem("token"));
          break;
        case "2":
          location.href = MOBILE_API.myclass;
          break;
        case "3":
          location.href = MOBILE_API.myclass;
          break;
        case "4":
          location.href = MOBILE_API.openBukeListeningHomePage;
          break;
        case "5":
          location.href = MOBILE_API.myclass;
          break;
        default:
          break;
      }
    },
    toWxDetail() {
      if (this.department == 1) {
        location.href = window.location.href
          .split("group_detail")
          .join("follow");
        // sessionStorage.setItem("token", localStorage.getItem("token"));
        // location.href =
        //   "https://code.knowbox.cn/activity/activitypage/newsuccess.html";
      } else {
        location.href = window.location.href
          .split("group_detail")
          .join("download");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.is_group {
  width: 100%;
  position: relative;
  overflow: hidden;
  .groupDesc {
    margin-top: 0.39rem;
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  .title {
    font-family: PingFangSC-Regular;
    font-size: 0.36rem;
    height: 0.36rem;
    line-height: 0.36rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #5f6162;
    margin: 0.42rem 0 0.49rem 0.41rem;
  }
  .status_icon {
    width: 1.34rem;
    height: 1.13rem;
    position: absolute;
    right: 0;
    top: 0.1rem;
  }
  .time {
    font-size: 0.24rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.28rem;
    height: 0.28rem;
    letter-spacing: 1px;
    color: #919294;
    padding-left: 0.41rem;
    margin-top: 0.38rem;
    span:nth-child(2) {
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #424243;
    }
  }
  button {
    width: 6rem;
    height: 1rem;
    background-color: #85cdf8;
    border-radius: 0.5rem;
    font-family: PingFangSC-Medium;
    font-size: 0.34rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
    box-shadow: 0px 0.04px 0.04px 0px #1aa6ff;
    position: fixed;
    bottom: 0.34rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>